import { Grid, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ProformaEmployeeCostReportSectionRef } from "../../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import {
  EMPLOYEE_COST_SECTION_TYPES,
  SELECTED_PERIOD,
} from "../../../../utils/constants/employee-cost-report-constants";
import { Header, StyledTableHead, StyledTable } from "../../styles";
import EmployeeCostPriceToTheClientSection from "../EmployeeCostSection/EmployeeCostPriceToTheClientSection";
import EmployeeCostSection from "../EmployeeCostSection/EmployeeCostSection";
import { ProformaEmployeeCostReportContext } from "../ProformaEmployeeCostReport";

interface Props {
  handleUpdateSection: (updatedSection: ProformaEmployeeCostReportSectionRef) => void;
  handleUpdateSelectedPeriod: (selectedPeriod: SELECTED_PERIOD) => void;
}

const EmployeeCostSchema = ({ handleUpdateSection, handleUpdateSelectedPeriod }: Props) => {
  const tRP = "components.add_edit_proforma_employee_cost_report";
  const { t } = useTranslation();
  const { report, currentSocialSecurityConfig } = useContext(ProformaEmployeeCostReportContext);

  return report ? (
    <Grid
      id="proforma-employee-cost-report-cost-schema"
      style={{
        width: "48%",
        // overflowY : "auto"
      }}
    >
      <StyledTable size="small">
        <StyledTableHead>
          <TableRow>
            <Header colSpan={3}>
              <Typography>{`${t(`${tRP}.employee_cost_schema`)}`}</Typography>
            </Header>
          </TableRow>
          <TableRow>
            <TableCell align="center">{`${t(`${tRP}.section`)}`}</TableCell>
            <TableCell align="center">{`${t(`${tRP}.rate`)}`}</TableCell>
            <TableCell align="center">{`${t(`${tRP}.amount`)}`}</TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {report.sections
            .filter((section) => !section.type?.type?.isPaySchemaRelated)
            .sort((a, b) => (a.type?.sequence ?? 0) - (b.type?.sequence ?? 0))
            .map((section, idx) => {
              const nextSection = report.sections
                .filter((section) => !section.type?.type?.isPaySchemaRelated)
                .sort((a, b) => (a.type?.sequence ?? 0) - (b.type?.sequence ?? 0))
                .find(
                  (_section) =>
                    section.type?.sequence &&
                    (_section.type?.sequence === section.type.sequence + 0.1 ||
                      _section.type?.sequence === section.type.sequence + 1)
                );

              return (
                <React.Fragment key={idx}>
                  {section.type?.type?.id !== EMPLOYEE_COST_SECTION_TYPES.Price_to_the_client.id ? (
                    <EmployeeCostSection
                      key={idx}
                      section={section}
                      handleUpdateSection={handleUpdateSection}
                      contributingSections={report.sections.filter(
                        (sec) => section.type && sec.type?.contributesTo.map((sec) => sec.id).includes(section.type?.id)
                      )}
                      proportionalToSection={
                        section.type?.proportionalTo
                          ? report.sections.find((sec) => sec.type?.id === section.type?.proportionalTo?.id) ?? null
                          : null
                      }
                      socialSecuritySection={
                        currentSocialSecurityConfig?.socialSecuritySections.find(
                          (ssSection) => ssSection.section?.id === section.type?.id
                        ) ?? null
                      }
                    />
                  ) : (
                    <EmployeeCostPriceToTheClientSection
                      section={section}
                      selectedPeriod={report.selectedPeriod}
                      handleUpdateSection={handleUpdateSection}
                      handleChangeSelectedPeriod={handleUpdateSelectedPeriod}
                      contributingSections={report.sections.filter(
                        (sec) => section.type && sec.type?.contributesTo.map((sec) => sec.id).includes(section.type?.id)
                      )}
                    />
                  )}
                  {section.type?.legislationEmployeeCostSectionGroup?.id !==
                    nextSection?.type?.legislationEmployeeCostSectionGroup?.id && (
                    <TableRow>
                      <TableCell colSpan={3}></TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              );
            })}
        </TableBody>
      </StyledTable>
    </Grid>
  ) : (
    <Typography>No report</Typography>
  );
};
export default EmployeeCostSchema;
